var _defs, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _rect2, _path42, _path43, _path44, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path45, _rect13, _path46, _rect14, _rect15, _g2, _circle, _path47, _g3, _path48, _path49, _g4, _line, _line2, _path50, _line3, _line4, _line5, _line6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectingTeams(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "abe81e00-bd8b-4196-8966-c2b5997f8608",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e53d6950-f44e-4f6e-9f0b-c6da13f4a342"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "b8f37fbd-6a3d-442b-9ae8-72d1abde601e",
    "data-name": "SVGID",
    cx: 454.89,
    cy: 114.19,
    r: 57.77,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e3778b95-0cc2-42bc-b684-0864e71f8bd7"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "a63523ef-9860-4124-92e8-6dcbbde552a3",
    "data-name": "SVGID",
    cx: 176.28,
    cy: 300.62,
    r: 71.37,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb66628f-d20a-4b92-815c-b63d7ef36510"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "b55c412a-731b-4362-8ab7-ad280d8741a3",
    "data-name": "SVGID",
    cx: 689.89,
    cy: 167.2,
    r: 63,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304,172H161.89a3,3,0,0,0-3,3v36.49a3,3,0,0,0,3,3H175v11.76l14.78-11.76H304a3,3,0,0,0,3-3V175A3,3,0,0,0,304,172Z",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M690.23,44.72H548.17a3,3,0,0,0-3,3V84.22a3,3,0,0,0,3,3H662.33L677.11,99V87.23h13.12a3,3,0,0,0,3-3V47.74A3,3,0,0,0,690.23,44.72Z",
    fill: "#2f2e41"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ed3e7e25-4837-488f-8707-34f033e784d0",
    "data-name": "freepik--Desk--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.23,453.16H296.85c-1.41,0-2.55,1.91-2.55,4.28s1.13,4.3,2.54,4.31H311V662.83H317V461.75H572.26V662.83h6.09V461.75h14.88c1.41,0,2.55-1.92,2.55-4.29s-1.13-4.3-2.54-4.3Z",
    fill: "#ccc"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M626.36,617.37s-.86,22.88,0,29.46c0,0,10,3.72,11.87,4s11.29,0,11.29,0v-32Z",
    fill: "#f9b499"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M602.62,661.56h0a7.86,7.86,0,0,1,4.17-6.93l15.85-8.37v-7.38a1.63,1.63,0,0,1,1.77-1.63l10.22.86a1.62,1.62,0,0,1,1.48,1.86l-1.17,7.72h14.58l1.15,13.87Z",
    fill: "#00ab55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M571.25,560.79s-10.21,20.5-12.13,26.84c0,0,7.58,7.52,9.16,8.54s10.29,4.66,10.29,4.66l13.2-29.19Z",
    fill: "#f9b499"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M531.41,591.28h0a7.86,7.86,0,0,1,6.67-4.6l17.88-1.1,3-6.72a1.64,1.64,0,0,1,2.28-.76l9,5a1.63,1.63,0,0,1,.57,2.31L566.58,592l13.29,6-4.67,13.12Z",
    fill: "#00ab55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M630,515.72c-10.14-.32-5.37-15.2-5.12-31.33.16-10.15,6.91-20.09,14.25-27.09a34.7,34.7,0,0,1,12.92-7.2c12.51-4.27,26.1-4.73,39.15-2.52C691.2,447.53,694.24,517.75,630,515.72Z",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M630,515.72c-10.14-.32-5.37-15.2-5.12-31.33.16-10.15,6.91-20.09,14.25-27.09a34.7,34.7,0,0,1,12.92-7.2c12.51-4.27,26.1-4.73,39.15-2.52C691.2,447.53,694.24,517.75,630,515.72Z",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 710.5,
    y: 513.95,
    width: 5.52,
    height: 133.44,
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M738.72,647.3H687.39s9.24-8.09,25.88-7.83C729.19,639.73,738.72,647.3,738.72,647.3Z",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M738.72,647.3H687.39s9.24-8.09,25.88-7.83C729.19,639.73,738.72,647.3,738.72,647.3Z",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M722.3,378.42c6.06-.54,12.23-1,18.19.17s11.75,4.31,15,9.5,3.29,11.75,3.29,17.82v77.45H689.61Z",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M758.79,479.79c.29,15.27-1,27.66-11.61,33.67-7.91,4.49-17.48,4.59-26.58,4.58H681.21c-4,0-8.28-.09-11.54-2.4-3.59-2.53-5.09-7.35-4.46-11.75a22.33,22.33,0,0,1,6-11.52c11.38-12.63,29.39-16.38,46.1-19.45",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M728.94,458.4s7.06,45.18-11.43,50.5c-19.67,5.68-61.81,16.3-61.81,16.3l-3.17,110.69-30.86-1.13-2.95-124.67a13.62,13.62,0,0,1,6.19-10.79l44.58-40.93Z",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M561.05,573.71l28.88,11.12,39.15-81.28s66.3,7.83,85.35,5.22c6.8-.92,14.84-4.47,18.89-9.63,7.38-9.42,7.71-22.3,6.33-34.19l-.55-2.61-48.86-2.61L615.4,471a20.31,20.31,0,0,0-15.06,11.75Z",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M561.05,573.71l28.88,11.12,39.15-81.28s66.3,7.83,85.35,5.22c6.8-.92,14.84-4.47,18.89-9.63,7.38-9.42,7.71-22.3,6.33-34.19l-.55-2.61-48.86-2.61L615.4,471a20.31,20.31,0,0,0-15.06,11.75Z",
    fill: "#231f20",
    opacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M716.48,332.81c1.23,2.13,4.28,2.48,6.53,1.52a20.05,20.05,0,0,0,5.66-4.58c1.75-1.71,3.92-3.33,6.29-3.46,1.84-.09,3.82.68,5.48-.15s2.25-3,3.07-4.79a14.52,14.52,0,0,1,3.69-4.69,9.13,9.13,0,0,0,2.22-11.14c-.08-.11-.14-.24-.22-.37A11.57,11.57,0,0,0,743,299.7c-2.22-.7-4.85-.57-6.53-2.14-2-1.81-1.81-5.05-3.42-7.2a8.46,8.46,0,0,0-5.39-2.85,33.75,33.75,0,0,1-6.11-1.3,5.79,5.79,0,0,1-3.91-4.43",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M705.32,288.34a13.66,13.66,0,0,0-24.21-3.78c-1.3,1.78-2.14,3.92-3.91,5.12-1.57,1-3.53,1.15-5.22,1.81a9,9,0,0,0-5.38,9.67c.45,2.33,1.83,4.59,1.31,6.9-.71,3.15-4.69,5-4.81,8.24-.07,2.18,1.71,3.92,3.44,5.32s3.65,2.79,4.12,4.93a31.14,31.14,0,0,1,0,4.32,6.26,6.26,0,0,0,6.29,5.54c1.65-.07,3.49-.78,4.8.21a11.82,11.82,0,0,1,1.31,1.61c1.53,1.68,4.31,1.63,6.33.57a21.07,21.07,0,0,0,5.09-4.51,10.23,10.23,0,0,1,5.73-3.51",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M716.84,331.77V355a13.62,13.62,0,0,1-13.62,13.62h0A13.62,13.62,0,0,1,689.61,355v-16.8c-6.82-4.32-11.11-13.58-10.27-23.9,1.11-13.71,10.85-24.1,21.75-23.21s18.83,12.72,17.72,26.43Z",
    fill: "#f9b499"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M689.61,338.47a30,30,0,0,0,15.87-4.24s-3.85,8.15-15.66,7Z",
    fill: "#f4a48e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M704.94,285.43a.41.41,0,0,1-.36-.17l-.72-.71,1.1.42a3,3,0,0,0,.58.19c.46.14.89,0,1,.24s-.39.61-1.13.43a1.26,1.26,0,0,1-.76-.51L705,285C705.05,285.23,705,285.39,704.94,285.43Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M704.8,286.78a9.81,9.81,0,0,0-2,9.06,10.56,10.56,0,0,0,6.72,6.81c.79.26,1.71.54,2,1.31a2.64,2.64,0,0,1-.32,1.94,9.62,9.62,0,0,0,3.49,11.21,13.26,13.26,0,0,0,3.92,12.1c0-2,1.53-3.8,3.21-5.08a32.28,32.28,0,0,0,5-3.82,8.12,8.12,0,0,0,1.08-9.2,5.64,5.64,0,0,1-1.11-2.74c0-1.18,1.07-2.06,1.88-2.95a10.44,10.44,0,0,0-.39-14.25c-.9-.88-2-1.59-2.79-2.53a40.34,40.34,0,0,1-2.61-4,13.32,13.32,0,0,0-13.17-5.09c-4.92,1-8,5.8-6.92,11.2",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M703.48,288.35a16.54,16.54,0,0,1-1.38,6.46,6.79,6.79,0,0,1-5,3.91c-2.15.25-4.21-.86-6.3-1.44-2.74-.77-6.16-.41-7.74,2-1.11,1.65-1.3,5.46-3.91,6.53-1.86.76-3-1.38-4.82-.55-3,1.38-2.52,6.62-5.57,8,1-2.53.51-5.35.48-8.05s.72-5.8,3.11-7.09a31.88,31.88,0,0,1,4.29-1.24c2.19-.81,3.72-2.78,5.31-4.52s3.59-3.41,5.94-3.35,4.26,1.7,6.53,1.59c1.81-.09,3.35-1.3,5-2.1s3.92-1,5,.39",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M727.51,291.43a5,5,0,0,0-1-.52,5.24,5.24,0,0,0-2.82-.32,17.83,17.83,0,0,0-4.11,1.41,11.83,11.83,0,0,1-5.43,1,11.63,11.63,0,0,1-5.29-1.61,11.15,11.15,0,0,1-3.3-3.08,10.29,10.29,0,0,1-1.4-2.69,2.7,2.7,0,0,1-.23-1.09,19.51,19.51,0,0,0,2,3.49,11.63,11.63,0,0,0,3.23,2.82,11.35,11.35,0,0,0,5,1.49c3.82.33,6.77-2.08,9.44-2.24a5,5,0,0,1,3,.55C727.31,291,727.53,291.4,727.51,291.43Z",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M664.58,315a16.76,16.76,0,0,0,2.24.17,9.12,9.12,0,0,0,5.59-2.15,8.34,8.34,0,0,0,2.35-3.38,16.65,16.65,0,0,0,.85-4.75c.1-1.72.07-3.56.34-5.47a10.55,10.55,0,0,1,2.21-5.53,6.71,6.71,0,0,1,2.48-1.87,6.12,6.12,0,0,1,3-.4c2,.21,3.67.92,5.35,1.09a13,13,0,0,0,8.64-2,13.69,13.69,0,0,0,4.22-4.38c.74-1.31,1-2,1.06-2a1.85,1.85,0,0,1-.15.57,11.51,11.51,0,0,1-.69,1.57,13.15,13.15,0,0,1-4.18,4.65,13.34,13.34,0,0,1-9,2.2c-1.77-.18-3.51-.87-5.32-1.06a5.52,5.52,0,0,0-2.67.36,5.93,5.93,0,0,0-2.22,1.68,10,10,0,0,0-2.08,5.22c-.26,1.84-.25,3.67-.38,5.42a16.13,16.13,0,0,1-1,4.9,8.38,8.38,0,0,1-2.61,3.55,9,9,0,0,1-5.89,2.05,7.37,7.37,0,0,1-1.68-.22A4.24,4.24,0,0,1,664.58,315Z",
    fill: "#231f20",
    opacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M679.1,315.86a3.66,3.66,0,0,1-.5,1.77,11.78,11.78,0,0,1-6.41,6c-1.09.39-1.79.47-1.82.38a22.31,22.31,0,0,0,5.15-3.26A23.32,23.32,0,0,0,679.1,315.86Z",
    fill: "#231f20",
    opacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M749.82,314.82a8.67,8.67,0,0,0-.43-2.42A7.1,7.1,0,0,0,748,310a7,7,0,0,0-3.1-2,10.86,10.86,0,0,0-4.54,0,11.93,11.93,0,0,1-2.67.12,5.26,5.26,0,0,1-2.71-1.06c-1.59-1.31-2.42-3.19-3.61-4.79a5.67,5.67,0,0,0-5.14-2.61,36.21,36.21,0,0,0-6.21,1.09,14,14,0,0,1-14.18-6.12,13.75,13.75,0,0,1-2.12-6.52,11.68,11.68,0,0,1,0-1.87,2,2,0,0,1,.11-.64s0,.9.12,2.48a14.11,14.11,0,0,0,2.27,6.23A13.52,13.52,0,0,0,719.81,300a34.84,34.84,0,0,1,6.33-1.12,6.33,6.33,0,0,1,5.68,3c1.22,1.7,2,3.55,3.47,4.69a6.28,6.28,0,0,0,4.92.87,11.19,11.19,0,0,1,4.75.12,7.47,7.47,0,0,1,4.66,4.84,6.48,6.48,0,0,1,.26,1.86A2.32,2.32,0,0,1,749.82,314.82Z",
    fill: "#231f20",
    opacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M741.13,323.26a1.72,1.72,0,0,1-1.38.83,3.35,3.35,0,0,1-1.92-.31A4.63,4.63,0,0,1,736,322a17.84,17.84,0,0,1-1.22-2.8,7.73,7.73,0,0,0-1.63-2.85,5.47,5.47,0,0,0-3.29-1.31c-1.3-.13-2.67-.17-4.07-.25a24,24,0,0,1-7.83-1.37,9.93,9.93,0,0,1-5.09-4.07,7.19,7.19,0,0,1-1-4.27,4.7,4.7,0,0,1,.25-1.17,1.29,1.29,0,0,1,.18-.38,9,9,0,0,0-.16,1.57,7.2,7.2,0,0,0,1.18,4,9.69,9.69,0,0,0,4.9,3.74,24.52,24.52,0,0,0,7.68,1.3c1.39.08,2.76.12,4.11.26a6,6,0,0,1,3.64,1.52,7.81,7.81,0,0,1,1.71,3.05,17.72,17.72,0,0,0,1.1,2.75A4.05,4.05,0,0,0,738,323.4a3.21,3.21,0,0,0,1.71.39A2.86,2.86,0,0,0,741.13,323.26Z",
    fill: "#231f20",
    opacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M620,389.87l-5.3-6.53c-3.21-4.86.64-7.41,1-8.48a12.19,12.19,0,0,1,2.52-4.53l-1.19-2a54.26,54.26,0,0,1-4-6.46c-.46-1.3,1.79-2.31,2.61-1.21,1.88,2.5,5.11,6.72,6.52,8.18,1.86,1.93,6.35,7.13,7,2.52s-.44-6.71-.53-8a1.51,1.51,0,1,1,3,0c.2,1.17.82,3.1,1.19,5.92.16,1.3.09,2.91.22,4.16.17,1.47,2,6.46,2.17,7.5Z",
    fill: "#f9b499"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M668.13,363.43l-17.49,43.69-14.28-28.59-18.07,10.78,17.63,36a16.38,16.38,0,0,0,15.48,9.06,15.13,15.13,0,0,0,11.86-7c6.43-10.25,16.5-34.82,16.5-34.82C679.77,393.81,668.13,363.43,668.13,363.43Z",
    fill: "#00ab55"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M731.93,398.55l8.82-38.15c-9.13-8.79-23.11-9.53-23.11-9.53l-4.55,3.06a15.86,15.86,0,0,1-18.38-.52l-3.35-2.54c-10.81,1.31-18.66,4.94-23.23,12.6l4.78,38,5.55,18.27L667.61,459.4l72.65,3.1-13.35-46.16c-.58,1,5-17.77,5-17.77",
    fill: "#00ab55"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M733.56,405.37a15,15,0,0,0-.45-1.84c-.32-1.17-.76-2.88-1.18-5a70,70,0,0,1-1.3-17,44.45,44.45,0,0,1,1.3-9.24,18,18,0,0,1,3.3-6.74,13,13,0,0,1,3.92-3.28c1.07-.56,1.74-.74,1.71-.8s-.17,0-.48.11a7.65,7.65,0,0,0-1.31.49,12.57,12.57,0,0,0-4.08,3.23,17.69,17.69,0,0,0-3.5,6.86,44,44,0,0,0-1.31,9.35,65.37,65.37,0,0,0,1.37,17c.49,2.14,1,3.83,1.31,5,.18.57.35,1,.46,1.3A1.48,1.48,0,0,0,733.56,405.37Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M704,456a130.33,130.33,0,0,1-12.24,7.43c-5.36,2.54-5.61,2.07-5.82,1.41-.56-1.81,9.25-4.85,6.73-5.41s-11.53,5.11-12,3.2c-.65-2.48,9.68-5.48,10.53-5.79s.4-1.56-.35-1.23c-1.09.47-12.62,5.14-13.29,2.7-.38-1.3,2.14-1.72,2.14-1.72s11.13-3.59,10.77-4.73-7,.73-9.14,1.52-3.43.09-3-1.15c.29-.84,6.91-3.42,9.07-4.15s8.18-2.61,4.4-4.09-6.16-3.91-6.34-5,1.3-1.72,2.22-.83a15.44,15.44,0,0,0,3.47,2.14,9.87,9.87,0,0,0,3.14.92c.94.12,1.79.19,2.53.24l8,.61,4.06,10.64Z",
    fill: "#f9b499"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M739.2,358.9a28.3,28.3,0,0,1,9.52,14.24c1.78,5.85,6.9,25.6,10.67,40.32A18.86,18.86,0,0,1,747.05,436l-42.56,23-7-18,37.33-24.53-9-33.42c-1.49-5.08-2.13-10.25-.26-15.21S731.36,358,739.2,358.9Z",
    fill: "#00ab55"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M749.52,435l-.19.14-.63.35-2.41,1.31-9.14,5-32.48,17.46-.3.17-.13-.33c-2.15-5.57-4.52-11.63-7-18l-.1-.25.23-.14,16.73-11,20.6-13.52-.13.35c-2.46-9.2-4.29-17.87-6-25.62-.43-1.95-.84-3.84-1.31-5.65a46.17,46.17,0,0,1-1-5.35,27.36,27.36,0,0,1,.81-9.62,14.19,14.19,0,0,1,4-6.71,10.43,10.43,0,0,1,5.3-2.49,8.5,8.5,0,0,1,3.65.22,5.51,5.51,0,0,1,1.18.48,9.65,9.65,0,0,0-1.2-.37,9,9,0,0,0-3.61-.11,10.28,10.28,0,0,0-5.1,2.51,13.9,13.9,0,0,0-3.91,6.59,26.86,26.86,0,0,0-.72,9.45,43.15,43.15,0,0,0,1,5.28c.4,1.83.82,3.71,1.3,5.64,1.76,7.74,3.64,16.42,6.1,25.58l.06.23-.19.13-20.58,13.54-16.76,11,.13-.39,6.93,18-.43-.16,32.62-17.25,9.26-4.84,2.46-1.31.64-.31Z",
    fill: "#231f20",
    opacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M679.76,372.64a6.26,6.26,0,0,1,.07,1.73,19.25,19.25,0,0,1-.78,4.64,65.85,65.85,0,0,1-2.33,6.53,44.11,44.11,0,0,0-2.61,8,23.84,23.84,0,0,0,0,8.34,48.49,48.49,0,0,0,1.6,6.71c.59,1.88,1.11,3.39,1.46,4.43a9,9,0,0,1,.49,1.66,6.9,6.9,0,0,1-.74-1.55c-.43-1-1-2.52-1.67-4.39a44.76,44.76,0,0,1-1.76-6.76,24.19,24.19,0,0,1,0-8.57,42.71,42.71,0,0,1,2.61-8.12,69.58,69.58,0,0,0,2.47-6.52A30.58,30.58,0,0,0,679.76,372.64Z",
    fill: "#231f20",
    opacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M735.61,416.11c0-.07.43-.26,1.22-.24a5.66,5.66,0,0,1,4.89,3.12c.34.7.37,1.18.29,1.21a7.62,7.62,0,0,0-6.4-4.09Z",
    fill: "#231f20",
    opacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M702.58,385.64a.91.91,0,0,1,.09-.17A4.84,4.84,0,0,1,703,385a5.17,5.17,0,0,1,1.67-1.3,5,5,0,0,1,3.37-.41,5.22,5.22,0,0,1,3.49,2.8,5.47,5.47,0,0,1-.35,5.39l-3.46,5.14-8,11.74v.1h-.1l-.92.35-7.63,2.88-.46.17v-9.38c3.45-5,6.37-9.14,8.47-12.24l2.56-3.45a8.54,8.54,0,0,1,.91-1.17,8,8,0,0,1-.75,1.3l-2.3,3.53-8.28,12.37v8.56l-.44-.31,7.56-2.86.91-.34-.17.12c2.86-4.17,5.56-8.12,8-11.75l3.49-5.1a5,5,0,0,0,.4-4.87,4.81,4.81,0,0,0-6.32-2.34A6.9,6.9,0,0,0,702.58,385.64Z",
    fill: "#e0e0e0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M699.55,408.09a36.9,36.9,0,0,1-8.14-5.67A36.44,36.44,0,0,1,699.55,408.09Z",
    fill: "#e0e0e0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M694,410.2c-.18.08-.62-.6-1.3-1.22s-1.49-1-1.45-1.17,1-.1,1.88.64S694.15,410.15,694,410.2Z",
    fill: "#e0e0e0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M711.09,391a33.86,33.86,0,0,1-7.76-5.69A34.38,34.38,0,0,1,711.09,391Z",
    fill: "#e0e0e0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M695.48,404.92a13.45,13.45,0,0,1,1.49-2.61c1-1.54,2.4-3.66,4-5.95s3-4.39,4.11-5.88a19.77,19.77,0,0,1,1.82-2.36c.22.14-2.2,4-5.37,8.61-1.58,2.31-3,4.38-4.15,5.85A12.78,12.78,0,0,1,695.48,404.92Z",
    fill: "#e0e0e0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M650.5,415.2a24.57,24.57,0,0,1,.14-8.25A25.66,25.66,0,0,1,650.5,415.2Z",
    fill: "#231f20",
    opacity: 0.2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M695.57,515.72c-10.14-.32-5.36-15.2-5.11-31.33.15-10.15,6.9-20.09,14.25-27.09a34.8,34.8,0,0,1,12.91-7.2c12.51-4.27,26.1-4.73,39.15-2.52C756.77,447.53,759.81,517.75,695.57,515.72Z",
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 401.5,
    y: 448.46,
    width: 87.08,
    height: 4.7,
    fill: "#2f2e41"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M332,261.2h226a6.38,6.38,0,0,1,6.38,6.38V422.2a0,0,0,0,1,0,0H325.65a0,0,0,0,1,0,0V267.58A6.38,6.38,0,0,1,332,261.2Z",
    fill: "#2f2e41"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M325.65,422.2V424a7.62,7.62,0,0,0,7.62,7.61h77.34v16.88h68.86V431.58H556a8.47,8.47,0,0,0,8.47-8.46v-.92Z",
    fill: "#2f2e41"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M325.65,422.2V424a7.62,7.62,0,0,0,7.62,7.61h77.34v16.88h68.86V431.58H556a8.47,8.47,0,0,0,8.47-8.46v-.92Z",
    fill: "#231f20",
    opacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 332.12,
    y: 268.41,
    width: 226.72,
    height: 149.05,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 332.12,
    y: 268.41,
    width: 226.72,
    height: 149.05,
    fill: "#231f20",
    opacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 336.83,
    y: 272.73,
    width: 216.91,
    height: 140.95,
    fill: "#fffdfd"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 343.9,
    y: 385.69,
    width: 164.26,
    height: 3.98,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 363.32,
    y: 394.66,
    width: 113.62,
    height: 3.67,
    rx: 1.66,
    fill: "#e4e4e4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 363.32,
    y: 401.74,
    width: 47.29,
    height: 3.67,
    rx: 1.66,
    fill: "#e4e4e4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 419.45,
    y: 401.74,
    width: 47.29,
    height: 3.67,
    rx: 1.66,
    fill: "#e4e4e4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 343.9,
    y: 394.66,
    width: 13.82,
    height: 10.76,
    fill: "#e4e4e4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 514.06,
    y: 272.73,
    width: 3.14,
    height: 138.56,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 522.33,
    y: 291.36,
    width: 26.65,
    height: 26.65,
    fill: "#e4e4e4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M532.83,300.71l6.37,3.38a.76.76,0,0,1,.06,1.31l-6.37,4.16a.76.76,0,0,1-1.18-.63v-7.55A.76.76,0,0,1,532.83,300.71Z",
    fill: "#2f2e41"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 522.33,
    y: 357.26,
    width: 26.65,
    height: 26.65,
    fill: "#e4e4e4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M532.83,366.61,539.2,370a.76.76,0,0,1,.06,1.31l-6.37,4.17a.76.76,0,0,1-1.18-.64v-7.54A.76.76,0,0,1,532.83,366.61Z",
    fill: "#2f2e41"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 522.33,
    y: 329.97,
    width: 26.65,
    height: 17.15,
    fill: "#e4e4e4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 522.33,
    y: 391.46,
    width: 26.65,
    height: 17.15,
    fill: "#e4e4e4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e53d6950-f44e-4f6e-9f0b-c6da13f4a342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fca5c30a-445e-4b6e-9069-0857008c85bf",
    "data-name": "freepik--Character2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.46,163.86s20-16.84,36.64-22,54.8,7.92,54.8,7.92-4.13,15-29.22,22.61-36,7.1-49.51,1.64S417.46,163.86,417.46,163.86Z",
    fill: "#00ab55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.86,135.64a140.16,140.16,0,0,1,4.62,15.68c1.81,8.09,5.28,13.2,11.06,7.1s7.26-18.32,7.26-22.09-.33-11.06-.33-11.06-7.92,12.22-12.22,13.37S444.86,135.64,444.86,135.64Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.86,135.64a140.16,140.16,0,0,1,4.62,15.68c1.81,8.09,5.28,13.2,11.06,7.1s7.26-18.32,7.26-22.09-.33-11.06-.33-11.06-7.92,12.22-12.22,13.37S444.86,135.64,444.86,135.64Z",
    fill: "#f4a48e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.13,112.39s-2.15-3.46-3.8-.32.66,7.76,2.32,9.74,4.28,3.46,4.62,1.63S434.13,112.39,434.13,112.39Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.72,82.69s-3.92,1.5-4.43,5.3a9,9,0,0,0,1.63,6.43s-2.77,2.74-2.15,6.21,4.73,5.09,4.73,5.09-1.11,3.45.86,5.9,4.82.76,4.82.76a3.9,3.9,0,0,0,2.35,3.49c2.45,1.07,5.67.08,5.67.08a10.07,10.07,0,0,0,2.93.56c2.19.2,4.48-2.37,4.48-2.37l35.28-5.24a6,6,0,0,0,4.24-3.27c1.2-2.76-2-9.38-2-9.38s3.27-1.34,2.3-6.2S480,84.13,480,84.13s2-6.74-1.77-9.73-6.17-1.47-6.17-1.47-3-6.45-7.77-6.17-6.11,1.31-6.11,1.31-3.5-3.12-7.15-2.67a5.67,5.67,0,0,0-4.7,3.06s-6.85-2.52-10.06-.13a16.46,16.46,0,0,0-4.55,5s-4.19-.75-5.84,1.83a11.7,11.7,0,0,0-1.64,5.73S422.55,80.45,421.72,82.69Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.16,102.63a157.52,157.52,0,0,0,6.11,22.78c4.09,11.55,9.57,15.84,15.18,17.66s14-9.58,16.18-16.84,2-8.59,2-8.59,5.94-1.48,7.59-7.26-2.46-9.41-5.78-8.09-4,5.62-4,5.62-5.61-3-7.76-6.77a11.85,11.85,0,0,1-1.82-6.6s-5.44-4.46-15.67-2.64A14.62,14.62,0,0,0,431.16,102.63Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.08,115.83a63,63,0,0,1-5.61,22.61,87,87,0,0,1-13.37,19.63s-5.61-.65-13.36-12.87a55.71,55.71,0,0,1-8.43-24.26",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.9,113s1.15-3.47-.16-4.29-2.65,1.49-2.32,2.64l.33,1.16s-.16,3.13.33,3.27S474.9,113,474.9,113Z",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.1,158.08s1.64,13.7,4.46,21.27",
    fill: "none",
    stroke: "#3f3d56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.62,133.16s-5.29,2.64-4.79,4.62a2.46,2.46,0,0,0,3,1.82,2.38,2.38,0,0,0,.51-.18c1.15-.5,4.29-1.64,4.29-1.64l2.15,4.3s-3.64-2.32-5.45-1.64a12.41,12.41,0,0,0-3.47,2.14,2,2,0,0,0-2.77.75l0,.07a8.5,8.5,0,0,0-1.33,3.27,4.81,4.81,0,0,0-1.82,3.63c0,2.31,0,4.09,1.49,5.45a4,4,0,0,0,2.46,1.32l1.31.82s-3.27,7.26-1.31,11.05,3,3.47,3,3.47l3.95,7.27,10.57-2.61-5.44-12.22s9.07-18.65,8.08-21.62-5.09-6.77-7.55-9.24A5.18,5.18,0,0,0,469.62,133.16Z",
    fill: "#f9b499"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "bd2d16df-92a6-406b-8ba9-06ef9f0aaf3a",
    "data-name": "SVGID",
    cx: 454.89,
    cy: 114.19,
    r: 57.77,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M436,177.72S377.57,187,382.62,225.3a10,10,0,0,0,14.82,7.7,8.58,8.58,0,0,0,4.4-10.77c-1.14-2.76-3.9-5.1-10.18-4.42-16.11,1.77-25.71,19.4-18.37,33.86a38.62,38.62,0,0,0,7.95,10.42,53.78,53.78,0,0,0,16.59,10.59c7.84,3.23,25,12.4,31.22,32.51",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "aa221fb9-ed44-40ff-b7f1-adfcb4ee1329",
    "data-name": "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e3778b95-0cc2-42bc-b684-0864e71f8bd7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.35,336.35s4.84,18.34,9.72,26.44,7.74,11.08,7.74,11.08c-12.33-1.49-23.52-4.31-33.85-11.22-23-13.27-30.25-33.83-30.25-33.83l31.17-12Z",
    fill: "#00ab55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.65,334.87a24.62,24.62,0,0,0-1.25,5.8c-.21,2.91,0,6.64-1.25,5.81s-4.56-7.89-4.56-7.89Z",
    fill: "#00ab55"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.23 320.97 165.64 334.87 155.9 342.54 148.42 329.06 154.23 320.97",
    fill: "#00ab55"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.23 320.97 165.64 334.87 155.9 342.54 148.42 329.06 154.23 320.97",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.23,290.68s-3.11,10.38-5.59,16a70.24,70.24,0,0,0-3.32,8.5,32.42,32.42,0,0,0,3.1,9.13c2.7,5.6,5,9.33,5.19,8.71s-1.24-4.77,4.77-12.24S167.3,310,167.3,310Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.11,308.93a34.63,34.63,0,0,0,5.18,13.91,107.29,107.29,0,0,0,7.89,10.37l-12,14.34a52.18,52.18,0,0,0-4-15.58,51.58,51.58,0,0,1-4.15-14.11Z",
    fill: "#00ab55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.11,308.93a34.63,34.63,0,0,0,5.18,13.91,107.29,107.29,0,0,0,7.89,10.37l-12,14.34a52.18,52.18,0,0,0-4-15.58,51.58,51.58,0,0,1-4.15-14.11Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.57,280.31s-5.81,21.57-13.48,33.19-13.9,12.86-19.3,10.58-11.41-14.52-13.28-19.29-2.9-7.47-2.9-7.47-3.52,6-7.67-1.25-3.32-14.11-.62-17a10.69,10.69,0,0,1,5.8-3.32s8.93-1.24,7.47-6,13.9-16.39,31.53-12.65S202.57,280.31,202.57,280.31Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,279.89a5,5,0,0,0-2.28,3.32c-.42,2.29.41,6.64-3.12,7.06s-7.46-3.12-8.91-3.74-3.32,2.7-6-6.22,2.28-23.85,7.67-25.93,12.45-1.66,12.45-1.66,4.77-5.6,21.16-5.6,28.62,7.88,25.72,10-4.56,2.28-4.56,2.28,9.13,7.05,8.71,15.35-7.67,9.54-13.69,7.05-11.2-12-11.2-12,3.53,10-.83,8.51-9.12-8.92-15.76-11.21-7.89-1.25-7.89-1.25,10.16,3.74,6,8.31S163,279.89,163,279.89Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.39,280.51S152,252.72,158.59,250s8.3-.83,8.3-.83-11.61,14.31-15.35,30.29Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.39,280.51S152,252.72,158.59,250s8.3-.83,8.3-.83-11.61,14.31-15.35,30.29Z",
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.56,313.71a2.67,2.67,0,0,0-1.93.85c-18.39-5.81-19.22-18.39-19.25-18.95a1.19,1.19,0,0,0-1.21-1.17h-.06a1.21,1.21,0,0,0-1.17,1.26v0c0,.61.86,14.82,21,21.19a2.69,2.69,0,1,0,2.63-3.2Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.78,
    cy: 288.2,
    rx: 8.82,
    ry: 9.96,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.78,
    cy: 288.2,
    rx: 8.82,
    ry: 9.96,
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.94,375.53l9.4-24.43a4.69,4.69,0,0,1,3.67-3l52.46-8.37a1.76,1.76,0,0,1,2,1.47,1.72,1.72,0,0,1-.15,1l-10,20.81Z",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "ffe1dd53-7ac1-4c30-8d09-d8548f581ce9",
    "data-name": "SVGID",
    cx: 176.28,
    cy: 300.62,
    r: 71.37,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M255.58,307.91s27.27-23.43,48.65-12.46A16.26,16.26,0,0,1,313,306.86c.73,4.05-.15,8.35-7.16,8.42a7.26,7.26,0,0,1-7.35-6.8c-.26-4.44,2.31-9.18,16.15-6.25a93.47,93.47,0,0,1,9.79,3c2.16.78,4.28,1.68,6.37,2.65,9,4.21,46.5,20.5,63.66,10.46",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M634.51,209.61s-3.6,47.61-34,57.39a21.59,21.59,0,0,1-18.93-2.49c-4.49-3.12-7.69-8-1.18-14.64a9.65,9.65,0,0,1,13.28-.52c4.42,3.94,6.46,10.8-9.29,21a125,125,0,0,1-12,6.38c-2.77,1.3-5.6,2.45-8.47,3.5-12.44,4.54-102.37,15.71-109.06,41.25",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "a9d96bbb-0bc0-41dd-a31d-f913e6b77ce8",
    "data-name": "freepik--character-3--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb66628f-d20a-4b92-815c-b63d7ef36510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M682.05,127.15a72.66,72.66,0,0,1-11,.78c-6.38,0-17.94.58-18.56,12.56s9.67,14.7,15.46,14.53a22,22,0,0,0,9.09-1.94s3.48,17.39-3.09,26.48-14.52,13.14-16.82,24-1,14.11-1,14.11,30.93,12,52.19,5,23.57-4.83,35-21.65-1.35-21.45-8.7-28.19S718.2,159.48,720.51,150s4.49-13.57-4-21.7-17.39-7.74-22.21-4.83S682.05,127.15,682.05,127.15Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.05,140a8.18,8.18,0,0,1,5.86,2c6.65,5,13.27,6.43,21.17.6a83.65,83.65,0,0,0,12-10.44",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.51,142.83a7,7,0,0,1,1.87-1.8",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.35,207.05a8.57,8.57,0,0,1-3.41,2.35",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.86,142s-5,6.67-1.67,12.49,15,6.66,25.39,20c6.61,8.47,7.5,19.12,5.12,26.48",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.82,171.13s18.72,12.9,12.07,30.75",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.36,208.74s19.07-4.34,29-11,16.86-5.95,21.38-3.66,20,20.15,27.74,23.58l7.8,3.43s-8.42,11-33.08,10.31-37-5.06-43.77-10.31A27.93,27.93,0,0,1,642.36,208.74Z",
    fill: "#00ab55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.33,184.18a71.29,71.29,0,0,1-4.83,12.56c-3.48,7.15-4.83,12.76.39,13.14s12.76-7.73,14.52-12.17,5.8-22.21,5.8-22.21Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.39,147.26s-2.33,17.39-2.71,27.06,4.83,15.08,9.09,14.88S700.8,178.58,701,178s2.89-2.12,2.89-2.12.78,2.51,3.67.38,4.64-10.44,3.87-12.75-1.54-1.94-2.32-1.55-3.86,2.51-7.35,2.12-10-4.27-10.82-11.21-.19-9.27-.19-9.27S682.05,152.28,672.39,147.26Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.48,156.54s2.57-7.64-4.06-18.56c-5-8.31-13.72-11.79-17-11.6s-7.35.77-7.35.77l11.59-4.82s10.63,1.54,16,10,5.41,19.53,4.27,23.39l-1.16,3.87Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.48,156.54s2.57-7.64-4.06-18.56c-5-8.31-13.72-11.79-17-11.6s-7.35.77-7.35.77l11.59-4.82s10.63,1.54,16,10,5.41,19.53,4.27,23.39l-1.16,3.87Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.45,186.24A2.08,2.08,0,0,1,691,187c15-5.12,15.65-16.07,15.67-16.57a1,1,0,0,1,1-1h0a1.05,1.05,0,0,1,1,1.11c0,.55-.71,13-17.09,18.53a2.25,2.25,0,0,1-2.15,1.92,2.36,2.36,0,0,1,0-4.7Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 709.64,
    cy: 163.92,
    rx: 7.18,
    ry: 8.7,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 709.64,
    cy: 163.92,
    rx: 7.18,
    ry: 8.7,
    fill: "#231f20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.23,167.26s-1-1.59-1.7,2.77-.78,14.88-.78,14.88-1.93.21-4.44-5.35-2.13-6.93-3.1-3.75,2.32,9.31,3.28,11.29a20.86,20.86,0,0,0,1.55,2.77s-7.69,5-8.11,8.52,1.93,32.1,1.93,32.1l10.43-2-4.44-24.17s13.92-15.66,15.27-18.63-3.68-12.26-5.22-17.63-3.48-5-3.67-3.57a24.68,24.68,0,0,0-.19,3s-.4,11.5.38,15.85Z",
    fill: "#f9b499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.87,167.94s.78,10.64,1.71,14.31",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "a8cef13c-ea2d-49da-af06-a5f303116dba",
    "data-name": "SVGID",
    cx: 689.89,
    cy: 167.2,
    r: 63,
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 179.05,
    y1: 187.12,
    x2: 278.38,
    y2: 187.12,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.18
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 179.05,
    y1: 197.31,
    x2: 219.51,
    y2: 197.31,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.18
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M410.86,23.07V59.56a3,3,0,0,1-3,3H394.73V74.33L380,62.57H265.79a3,3,0,0,1-3-3V23.07a3,3,0,0,1,3-3H407.85A3,3,0,0,1,410.86,23.07Z",
    fill: "#ccc"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 390.7,
    y1: 35.21,
    x2: 291.36,
    y2: 35.21,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.18
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 390.7,
    y1: 45.41,
    x2: 350.24,
    y2: 45.41,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.18
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 673.07,
    y1: 59.87,
    x2: 573.74,
    y2: 59.87,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.18
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 673.07,
    y1: 70.07,
    x2: 632.61,
    y2: 70.07,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.18
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectingTeams);
export default __webpack_public_path__ + "static/media/Connecting-Teams.43dd738c63b5038c0c59f8df28ac08f6.svg";
export { ForwardRef as ReactComponent };